const translations = {
  common: {
    search: 'Cerca',
    searching: 'Ricerca in corso',
    signIn: 'Accedi',
    register: 'Registrati',
    myAccount: 'Il mio account',
    support: 'Supporto',
    followUs: 'Seguici su X/Twitter',
    proMembership: 'Abbonamento Pro',
    new: 'Nuovo',
    proMember: 'Membro Pro',
    upgrade: 'Aggiorna',
    subscribe: 'Abbonati',
    manage: 'Gestisci',
    cancel: 'Annulla',
    close: 'Chiudi',
    or: 'O',
    email: 'Indirizzo email',
    continue: 'Continua',
    submit: 'Invia',
    billing: 'Fatturazione',
    sort: 'Ordina',
    language: 'Lingua',
    selectLanguage: 'Seleziona lingua',
    searchPlaceholder: 'Cerca...',
    cards: 'Carte',
    previous: 'Precedente',
    next: 'Successivo',
    pagination: 'Paginazione',
    back: 'Indietro',
    backToSets: 'Torna ai Set',
    error: 'Si è verificato un errore. Riprova.',
    home: 'Home',
    sets: 'Set',
    login: 'Accedi',
    loginRequired: 'Accedi per utilizzare questa funzionalità',
    adding: 'Aggiunta in corso...',
  },
  languages: {
    default: 'Predefinito',
    any: 'Qualsiasi',
    english: 'Inglese',
    spanish: 'Spagnolo',
    french: 'Francese',
    german: 'Tedesco',
    italian: 'Italiano',
    portuguese: 'Portoghese',
    japanese: 'Giapponese',
    korean: 'Coreano',
    russian: 'Russo',
    simplified_chinese: 'Cinese Semplificato',
    traditional_chinese: 'Cinese Tradizionale',
    hebrew: 'Ebraico',
    latin: 'Latino',
    ancient_greek: 'Greco Antico',
    arabic: 'Arabo',
    sanskrit: 'Sanscrito',
    phyrexian: 'Phyrexiano',
    quenya: 'Quenya',
  },
  filters: {
    show: '✨ Mostra Filtri Pro',
    hide: '✨ Nascondi Filtri Pro',
  },
  search: {
    showing_start: 'Mostrando',
    showing_to: 'a',
    showing_of: 'di',
    showing_results: 'risultati',
    noResults: 'Nessun risultato trovato.',
    useSearchTip: 'Usa la ricerca in alto nella pagina per cercare una carta.',
  },
  sort: {
    nameAsc: 'Nome (A-Z)',
    nameDesc: 'Nome (Z-A)',
    cmcAsc: 'Costo di Mana (Basso-Alto)',
    cmcDesc: 'Costo di Mana (Alto-Basso)',
    usdAsc: 'Prezzo (Basso-Alto)',
    usdDesc: 'Prezzo (Alto-Basso)',
    rarityAsc: 'Rarità (Comune-Mitica)',
    rarityDesc: 'Rarità (Mitica-Comune)',
    releasedDesc: 'Data di Uscita (Più Recente Prima)',
    releasedAsc: 'Data di Uscita (Più Vecchia Prima)',
  },
  pages: {
    search: {
      heading: 'Ricerca Carte MTG',
    },
    sets: {
      heading: 'Set di Carte',
      latestSets: 'Ultimi Set',
      upcomingSets: 'Set in Arrivo',
      allSets: 'Tutti i Set',
      noResults: 'Nessun risultato trovato.',
    },
    set: {
      notFound: 'Set non trovato.',
      noCards: 'Nessuna carta trovata in questo set.',
      addAll: 'Aggiungi {{count}} Carte alla Lista Proxy',
      addedToList: 'Aggiunte {{count}} carte alla Lista Proxy',
    },
    tokens: {
      heading: 'Token',
    },
    emblems: {
      heading: 'Emblemi',
    },
    import: {
      heading: 'Importa carte nella Lista Proxy',
      description: 'Inserisci i nomi di tutte le carte che vuoi aggiungere alla Lista Proxy.',
    },
    topProxies: {
      heading: 'Proxy Popolari',
      description: 'Ecco le 50 carte proxy MTG più popolari su TCG Stacked.',
    },
  },
  theme: {
    light: 'Chiaro',
    dark: 'Scuro',
    toggle: 'Cambia tema',
  },
  cta: {
    title: 'Pronto a iniziare?',
    subtitle: 'Inizia a creare proxy oggi stesso.',
    searchByCard: 'Cerca per carta',
    searchBySet: 'Cerca per set',
  },
  nav: {
    magicTheGathering: 'Magic: The Gathering',
    pokemon: 'Pokémon',
    sets: 'Set',
    tokens: 'Token',
    emblems: 'Emblemi',
    import: 'Importa',
    topProxies: 'Proxy Popolari',
    customCards: 'Carte Personalizzate',
    deckBuilder: 'Costruttore di Mazzi',
    buildDeck: 'Costruisci Mazzo',
    publicDecks: 'Mazzi Pubblici',
    favoriteDeck: 'I Miei Mazzi Preferiti',
    articles: 'Articoli',
    feedback: 'Condividi Feedback',
    collection: 'La Mia Collezione',
    pokemonSets: 'Set Pokémon',
    pokemonSearch: 'Cerca Carte Pokémon',
  },
  seo: {
    collection: {
      title: 'La Mia Collezione di Carte | TCG Stacked',
      description: 'Gestisci la tua collezione personale di carte. Tieni traccia, organizza e valuta le tue carte Magic: The Gathering in un unico posto.',
    },
    home: {
      title: 'TCG Stacked - Carte Proxy di Giochi di Carte Collezionabili',
      description: 'Accedi a una vasta libreria di carte proxy di giochi di carte collezionabili. Visualizza e stampa facilmente immagini di carte per il gioco casual. Inizia a costruire il mazzo dei tuoi sogni oggi!',
    },
    sets: {
      title: 'Set di Carte - TCG Stacked',
      description: 'Esplora tutti i set di carte collezionabili e stampa proxy per il tuo mazzo.',
    },
    tokens: {
      title: 'Token - TCG Stacked',
      description: 'Migliora il tuo gioco con vari token proxy.',
    },
    emblems: {
      title: 'Emblemi - TCG Stacked',
      description: 'Stampa carte proxy emblema per il tuo mazzo.',
    },
    search: {
      title: 'Ricerca Carte - TCG Stacked',
      description: 'Trova e stampa facilmente carte proxy. Usa gli strumenti di ricerca per accedere a un vasto database e migliora i tuoi mazzi con le proxy.',
    },
    support: {
      title: 'Supporto - TCG Stacked',
      description: 'Inviaci una email se hai domande, feedback o vuoi aggiungere token/emblemi.',
    },
    articles: {
      title: 'Articoli - TCG Stacked',
      description: 'Articoli su giochi di carte collezionabili e carte proxy.',
    },
    import: {
      title: 'Importa - TCG Stacked',
      description: 'Importa una lista di carte per stampare proxy di giochi di carte collezionabili.',
    },
    topProxies: {
      title: 'Proxy Popolari - TCG Stacked',
      description: 'Visualizza le carte proxy più popolari su TCG Stacked.',
    },
    customCards: {
      title: 'Carte Personalizzate - TCG Stacked',
      description: 'Crea le tue carte proxy personalizzate di giochi di carte collezionabili.',
    },
    login: {
      title: 'Accedi - TCG Stacked',
      description: 'Accedi al tuo account per gestire carte personalizzate, liste dei mazzi e altro.',
    },
    register: {
      title: 'Registrati - TCG Stacked',
      description: 'Registra un account per gestire carte personalizzate, liste dei mazzi e altro.',
    },
    termsOfService: {
      title: 'Termini di Servizio - TCG Stacked',
      description: 'Leggi i termini di servizio del sito.',
    },
    privacyPolicy: {
      title: 'Informativa sulla Privacy - TCG Stacked',
      description: "Leggi l'informativa sulla privacy del sito.",
    },
    account: {
      title: 'Account - TCG Stacked',
      description: 'Gestisci il tuo account.',
    },
    proMembership: {
      title: 'Abbonamento Pro - TCG Stacked',
      description: "Abbonati all'abbonamento Pro per accedere a tutte le funzionalità del sito.",
    },
    deckBuilder: {
      title: 'Costruttore di Mazzi - TCG Stacked',
      description: 'Crea e gestisci i tuoi mazzi di giochi di carte collezionabili.',
    },
    deckEditor: {
      title: 'Editor di Mazzi - TCG Stacked',
      description: 'Crea e modifica i tuoi mazzi di giochi di carte collezionabili.',
    },
    publicDecks: {
      title: 'Mazzi Pubblici - TCG Stacked',
      description: 'Sfoglia ed esplora i mazzi pubblici condivisi dalla comunità.',
    },
  },
  pro: {
    pricing: {
      title: 'Potenzia la Tua Esperienza di Proxy',
      subtitle: "Diventa Pro e goditi un'esperienza premium senza pubblicità con funzionalità esclusive che portano i tuoi proxy al livello successivo!",
      monthlyPlan: 'Boost Mensile',
      yearlyPlan: 'Super Valore Annuale',
      monthlyPrice: '€5,00/mese',
      yearlyPrice: '€40,00/anno',
      subscribeMonthly: 'Inizia Subito',
      subscribeYearly: 'Risparmia Annualmente',
      signInToSubscribe: 'Accedi per Sbloccare Pro',
      manageSubscription: 'Gestisci Vantaggi Pro',
      nextBillingDate: 'Prossimo Pagamento',
      benefitsEndDate: 'Accesso Pro fino al',
      viewInvoice: 'Visualizza Ricevuta',
      changePlan: 'Cambia il Tuo Piano',
      reactivate: 'Ripristina Vantaggi Pro',
      active: 'Attivo e Fiorente',
      cancelled: 'Annullato',
      freeTrial: 'Prova Gratuita',
      freeTrialEnds: 'La Prova Gratuita Termina',
      startFreeTrial: 'Inizia la Prova Gratuita di 7 Giorni',
      signInForFreeTrial: 'Accedi per la Prova Gratuita di 7 Giorni',
      current: 'Attuale',
      subscribe: 'Abbonati',
    },
    benefits: {
      title: 'Perché Scegliere Pro con TCG Stacked?',
      subtitle: 'Unisciti a centinaia di giocatori che hanno migliorato la loro esperienza di proxy con queste funzionalità Pro esclusive!',
      noAds: {
        title: 'Esperienza Pura Senza Pubblicità',
        description: "Addio alle interruzioni! Goditi un'interfaccia impeccabile senza pubblicità, banner o pop-up. L'esperienza di gioco allo stato puro.",
      },
      darkMode: {
        title: 'Modalità Scura Epica',
        description: 'Delicata per i tuoi occhi ed elegante! Perfetta per i nottambuli e le sessioni maratona di proxy in qualsiasi condizione di illuminazione.',
      },
      advancedSearch: {
        title: 'Magia di Ricerca Pro',
        description: 'Trova esattamente ciò che ti serve con filtri potenti! Filtra per identità di colore, rarità, tipo di carta e altro per costruire il mazzo perfetto.',
      },
      multipleDecks: {
        title: 'Creazione Illimitata di Mazzi',
        description: 'Paradiso per i costruttori di mazzi! Crea e salva tutti i mazzi che desideri - dal divertimento casual alle potenti macchine competitive.',
      },
      futureFeatures: {
        title: 'Accesso Prioritario alle Novità',
        description: "All'avanguardia dell'innovazione! I membri Pro hanno sempre la priorità sulle nuove entusiasmanti funzionalità non appena vengono rilasciate.",
      },
      cancelAnytime: {
        title: 'Zero Rischi, Tutti i Vantaggi',
        description: 'Libertà totale! Nessun contratto a lungo termine o costi nascosti. Annulla con un semplice clic quando vuoi.',
      },
      prioritySupport: {
        title: 'Supporto VIP Esclusivo',
        description: 'Evita le attese! Le tue domande e richieste ricevono un trattamento prioritario dal nostro team di supporto dedicato.',
      },
    },
    features: {
      unlimitedDecks: 'Creazione mazzi senza limiti',
      noAds: 'Esperienza proxy senza pubblicità',
      prioritySupport: 'Accesso al supporto VIP',
      darkMode: 'Elegante interfaccia modalità scura',
      advancedSearch: 'Filtri e strumenti di ricerca Pro',
      futureFeatures: 'Funzionalità esclusive in arrivo',
      cancelAnytime: 'Disdetta senza complicazioni',
    },
    promotion: {
      title: 'Libera la Creazione Illimitata di Mazzi',
      description: 'Infrangi i limiti! Passa a Pro ora e costruisci tutti i mazzi che la tua immaginazione permette.',
      customizeTitle: "Trasforma le tue Carte con la Magia dell'IA",
      customizeDescription: "Passa a Pro e crea fino a 5 varianti personalizzate di carte al giorno grazie alla nostra tecnologia IA all'avanguardia!",
      banner: 'Prova Pro gratuitamente per 7 giorni! Nessuna pubblicità, modalità scura, mazzi illimitati e altro ancora.',
      tryNow: 'Prova Ora',
    },
    account: {
      title: 'Il Tuo Abbonamento Pro',
      description: 'Gestisci i tuoi vantaggi premium',
      subscribeToPro: 'Passa a Pro Adesso',
    },
  },
  auth: {
    signIn: {
      title: 'Accedi al Tuo Account',
      withGoogle: 'Continua con Google',
      withEmail: 'O continua con',
      sendMagicLink: 'Invia Link Magico',
      noAccount: 'Non hai un account?',
      checkEmail: 'Controlla la tua email per il link di accesso',
      errors: {
        failed: 'Accesso Fallito',
        failedGoogle: 'Accesso Google Fallito',
        failedEmail: 'Accesso Email Fallito',
        noEmail: 'Email non trovata',
      },
      terms: 'Accedendo, accetti:',
    },
    register: {
      title: 'Crea un Account',
      haveAccount: 'Hai già un account?',
      terms: 'Creando un account, accetti:',
    },
    common: {
      termsOfService: 'Termini di Servizio',
      privacyPolicy: 'Informativa sulla Privacy',
      and: 'e',
    },
  },
  home: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['carte', 'pedine', 'emblemi', 'planeswalker', 'comandanti', 'terre', 'creature', 'artefatti', 'incantesimi', 'istantanei'],
      description: 'TCG Stacked ti aiuta a creare proxy di carte di giochi di carte collezionabili da utilizzare nei tuoi mazzi casual gratuitamente!',
      search: {
        cards: {
          tab: 'Carte',
          placeholder: 'Cerca una carta collezionabile...',
          error: 'Errore nel caricamento delle carte casuali',
        },
        sets: {
          tab: 'Set',
          placeholder: 'Cerca un set di carte collezionabili...',
        },
        tokens: {
          tab: 'Pedine',
          placeholder: 'Cerca una pedina di carte collezionabili...',
        },
        button: 'Cerca',
        hint: {
          cards: 'Premi Invio o clicca su Cerca per trovare le tue carte',
          sets: 'Premi Invio o clicca su Cerca per trovare i tuoi set',
          tokens: 'Premi Invio o clicca su Cerca per trovare le tue pedine',
        },
        aria: {
          searchIcon: 'Icona di ricerca',
          searchInput: {
            cards: 'Cerca carte',
            sets: 'Cerca set',
            tokens: 'Cerca pedine',
          },
        },
      },
      images: {
        cardAlt: 'Immagine carta Magic',
      },
      processedCount: '🎉 Abbiamo elaborato oltre {{count}} proxy gratuite per la comunità! 🎉',
    },
    features: {
      section1: {
        badge: 'Stampa Proxy',
        title: 'Stampa Carte Proxy',
        subtitle: 'Aggiungi carte alla tua lista di stampa, stampale e utilizzale nei tuoi mazzi oggi stesso!',
        features: [
          {
            name: 'Aggiungi carte alla tua lista di stampa',
            description: 'Cerca qualsiasi carta usando la pagina di Ricerca o sfoglia per set e aggiungi le carte che desideri alla tua lista di stampa.',
          },
          {
            name: 'Stampa le tue carte',
            description: 'Una volta aggiunte tutte le carte che desideri alla tua lista di stampa, puoi stamparle e utilizzarle nei tuoi mazzi.',
          },
          {
            name: 'Utilizzale nei tuoi mazzi',
            description: "Una volta stampate le tue carte, puoi utilizzarle nei tuoi mazzi. Ritagliale e incollale su una terra base o usa una bustina con una terra base all'interno.",
          },
        ],
        images: {
          cartScreenshot: 'Screenshot del carrello che mostra come aggiungere carte alla tua lista di stampa',
        },
      },
      section2: {
        badge: 'Costruttore di Mazzi',
        title: 'Costruisci e gestisci Mazzi di Carte Collezionabili',
        subtitle: 'Crea e gestisci i tuoi mazzi, o sfoglia i mazzi pubblici creati dalla community.',
        features: [
          {
            name: 'Gestisci i tuoi Mazzi',
            description: 'Tutti gli utenti possono creare e gestire un mazzo. I membri Pro possono creare un numero illimitato di mazzi.',
          },
          {
            name: 'Stampa le tue carte',
            description: 'Una volta aggiunte tutte le carte che desideri al tuo mazzo, puoi aggiungerle alla tua Lista di Stampa tutte in una volta.',
          },
          {
            name: 'Sfoglia i Mazzi Pubblici',
            description: 'Aggiungi mazzi completi creati dalla community alla tua Lista di Stampa per testare facilmente nuovi mazzi.',
          },
        ],
        images: {
          deckBuilderScreenshot: 'Interfaccia del Costruttore di Mazzi che mostra come gestire i tuoi mazzi',
        },
      },
    },
  },
  footer: {
    copyright: 'TCG Stacked, Tutti i diritti riservati.',
    disclaimer: 'TCG Stacked non è prodotto, approvato, supportato o affiliato a nessun editore di giochi di carte collezionabili.',
    affiliate: 'Come partner affiliato di TCGplayer, TCG Stacked può guadagnare una commissione sugli acquisti idonei.',
    builtBy: 'Creato da',
    minnerLabs: 'Minner Labs',
    privacyPolicy: 'Politica sulla Privacy',
    termsOfService: 'Termini di Servizio',
    support: 'Supporto',
  },
  sort: {
    nameAsc: 'Nome (A a Z)',
    nameDesc: 'Nome (Z a A)',
    cmcAsc: 'Valore di Mana (Basso a Alto)',
    cmcDesc: 'Valore di Mana (Alto a Basso)',
    usdAsc: 'Prezzo (Basso a Alto)',
    usdDesc: 'Prezzo (Alto a Basso)',
    rarityAsc: 'Rarità (Comune a Mitica)',
    rarityDesc: 'Rarità (Mitica a Comune)',
    releasedDesc: 'Data di Pubblicazione (Prima i Nuovi)',
    releasedAsc: 'Data di Pubblicazione (Prima i Vecchi)',
  },
  pages: {
    search: {
      heading: 'Cerca',
    },
    sets: {
      heading: 'Set di Carte',
      latestSets: 'Set Recenti',
      upcomingSets: 'Set in Arrivo',
      allSets: 'Tutti i Set',
      noResults: 'Nessun risultato trovato.',
    },
    set: {
      notFound: 'Set non trovato.',
      noCards: 'Nessuna carta trovata in questo set.',
      addAll: 'Aggiungi {{count}} Carte alla Lista di Stampa',
      addedToList: 'Aggiunte {{count}} carte alla Lista di Stampa',
    },
    tokens: {
      heading: 'Token',
    },
    emblems: {
      heading: 'Emblemi',
    },
    import: {
      heading: 'Importa carte nella Lista di Stampa',
      description: 'Inserisci i nomi di tutte le carte che vuoi aggiungere alla Lista di Stampa.',
    },
    topProxies: {
      heading: 'Proxy Popolari',
      description: 'Ecco le 50 carte proxy più popolari su TCG Stacked.',
    },
  },
  languages: {
    default: 'Predefinito',
    any: 'Qualsiasi',
    english: 'Inglese',
    spanish: 'Spagnolo',
    french: 'Francese',
    german: 'Tedesco',
    italian: 'Italiano',
    portuguese: 'Portoghese',
    japanese: 'Giapponese',
    korean: 'Coreano',
    russian: 'Russo',
    simplified_chinese: 'Cinese semplificato',
    traditional_chinese: 'Cinese tradizionale',
    hebrew: 'Ebraico',
    latin: 'Latino',
    ancient_greek: 'Greco antico',
    arabic: 'Arabo',
    sanskrit: 'Sanscrito',
    phyrexian: 'Phyrexiano',
    quenya: 'Quenya',
  },
  filters: {
    show: '✨ Mostra filtri Pro',
    hide: '✨ Nascondi filtri Pro',
  },
  search: {
    showing_start: 'Mostrando',
    showing_to: 'a',
    showing_of: 'di',
    showing_results: 'risultati',
    noResults: 'Nessun risultato trovato.',
    useSearchTip: 'Usa la ricerca in cima alla pagina per cercare una carta.',
  },
  advancedFilters: {
    colors: 'Colori',
    rarity: 'Rarità',
    cardTypes: 'Tipi di Carta',
    format: 'Formato',
    manaValue: 'Valore di Mana',
    cardName: 'Nome Carta',
    cardText: 'Testo Carta',
    specialCharacteristics: 'Caratteristiche Speciali',
    activeFilters: 'Filtri Attivi',
    clearAll: 'Cancella Tutto',
    applyFilters: 'Applica Filtri',
    searchCardName: 'Cerca nome carta...',
    searchCardText: 'Cerca testo carta...',
    namePrefix: 'Nome: ',
    manaPrefix: 'Mana: ',
    textPrefix: 'Testo: ',
    removeFromFilter: '✕',
    selectLanguage: 'Seleziona lingua',
  },
  card: {
    addToPrintList: 'Aggiungi alla lista di stampa',
    removeFromPrintList: 'Rimuovi dalla lista di stampa',
    cardsInPrintList: 'carta nella lista di stampa',
    cardsInPrintListPlural: 'carte nella lista di stampa',
    buyOn: 'Compra su TCGplayer',
    buyFor: 'Compra per ',
    viewDetails: 'Visualizza dettagli',
    type: 'Tipo',
    manaCost: 'Costo di mana',
    rarity: 'Rarità',
    artist: 'Artista',
    collectorNumber: 'Numero del collezionista',
    oracleText: 'Testo Oracle',
    youMightAlsoLike: 'Potrebbe interessarti anche...',
    noRecommendations: 'Nessuna raccomandazione disponibile al momento.',
    details: 'Dettagli',
    rulings: 'Regole',
    legality: 'Legalità',
    share: 'Condividi',
    favorite: 'Preferito',
    noRulings: 'Nessuna regola disponibile per questa carta.',
    noLegalityInfo: 'Nessuna informazione sulla legalità disponibile per questa carta.',
    published: 'Pubblicato',
    legal: 'Legale',
    restricted: 'Limitato',
    banned: 'Bandito',
    format: 'Formato',
    status: 'Stato',
    viewMore: 'Mostra di più',
    viewLess: 'Mostra di meno',
    customizeWithAI: 'Personalizza con IA',
    otherVersions: 'Stampe uniche',
    showUniqueVersions: 'Mostra stampe uniche',
    hideUniqueVersions: 'Nascondi stampe uniche',
  },
  cart: {
    title: 'Lista di stampa',
    closePanel: 'Chiudi pannello',
    empty: 'Nessun proxy nella lista di stampa.',
    addPadding: 'Aggiungi spaziatura',
    paperSize: 'Dimensione carta',
    scale: 'Scala',
    clearCardList: 'Svuota lista',
    print: 'Stampa',
    success: 'Successo!',
  },
  setsList: {
    showing: 'Mostrando',
    to: 'a',
    of: 'di',
    results: 'risultati',
    searchPlaceholder: 'Cerca...',
  },
  customizeCardModal: {
    title: 'Personalizza Carta con IA',
    description: "Descrivi come vuoi personalizzare questa carta. L'IA genererà una nuova versione mantenendo la cornice e la struttura della carta.",
    buttonText: 'Personalizza con IA',
    placeholder: 'Descrivi la tua variante personalizzata della carta...',
    generateButton: 'Genera Carta Personalizzata',
    generatingButton: 'Generazione in corso...',
    addToPrintListButton: 'Aggiungi alla Lista di Stampa',
    successMessage: 'Carta personalizzata aggiunta alla lista di stampa',
    remainingGenerationsOne: '{{count}} generazione rimanente questo mese',
    remainingGenerationsOther: '{{count}} generazioni rimanenti questo mese',
    error: {
      failed: 'Impossibile generare la carta personalizzata',
    },
  },
  feedback: {
    buttonLabel: 'Feedback',
    title: 'Condividi il Tuo Feedback',
    description: 'Apprezziamo il tuo contributo per migliorare TCG Stacked. Condividi i tuoi pensieri con noi.',
    categoryLabel: 'Categoria',
    categories: {
      bug: 'Segnalazione Bug',
      feature: 'Richiesta Funzionalità',
      improvement: 'Suggerimento Miglioramento',
      general: 'Feedback Generale',
      other: 'Altro',
    },
    messageLabel: 'Il Tuo Feedback',
    messagePlaceholder: 'Condividi i tuoi pensieri, suggerimenti o segnala un problema...',
    ratingLabel: 'Valuta la Tua Esperienza (Opzionale)',
    emailLabel: 'Email (Opzionale)',
    emailPlaceholder: 'tua@email.com',
    emailHelp: 'Fornisci la tua email se desideri che ti contattiamo.',
    submitting: 'Invio in corso...',
    submitButton: 'Invia Feedback',
    successMessage: 'Grazie per il tuo feedback!',
    errorMessage: 'Impossibile inviare il feedback. Riprova.',
  },
  collection: {
    title: 'La Mia Collezione',
    loginRequired: 'Accesso Richiesto',
    loginMessage: 'Effettua il login per visualizzare la tua collezione',
    emptyCollection: 'Nessuna Carta Trovata',
    emptyCollectionMessage: 'La tua collezione è vuota. Aggiungi carte dalla pagina dei dettagli della carta o usa la funzione Aggiungi in Blocco.',
    noMatchingCards: 'Nessuna carta corrisponde ai tuoi filtri.',
    searchPlaceholder: 'Cerca carte...',
    sortBy: 'Ordina per',
    sortName: 'Nome',
    sortPrice: 'Prezzo',
    sortDate: 'Data Aggiunta',
    sortQuantity: 'Quantità',
    filterRarity: 'Rarità',
    filterSet: 'Set',
    allRarities: 'Tutte le Rarità',
    allSets: 'Tutti i Set',
    filters: 'Filtri',
    clearFilters: 'Cancella Filtri',
    sortAscending: 'Ordine Crescente',
    sortDescending: 'Ordine Decrescente',
    bulkAdd: 'Aggiungi in Blocco',
    bulkAddTitle: 'Aggiungi Carte dalla Lista di Stampa',
    bulkAddDescription: 'Aggiungi tutte le carte dalla tua lista di stampa alla tua collezione.',
    bulkAddCount: '{{count}} carte saranno aggiunte alla tua collezione.',
    emptyCart: 'La tua lista di stampa è vuota',
    bulkAddSuccess: 'Carte aggiunte alla collezione',
    bulkAddError: 'Impossibile aggiungere carte alla collezione',
    addToCollection: 'Aggiungi alla Collezione',
    addMore: 'Aggiungi Altro',
    inCollection: 'In Collezione',
    quickAdd: 'Aggiunta Rapida',
    searchCards: 'Cerca carte...',
    typeToSearch: 'Digita almeno 3 caratteri per cercare',
    noResults: 'Nessun risultato trovato',
    noCardSelected: 'Nessuna carta selezionata',
    addCardToCollection: 'Aggiungi Carta alla Collezione',
    addCardDescription: 'Specifica la quantità da aggiungere alla tua collezione.',
    quantity: 'Quantità',
    price: 'Prezzo',
    addToCart: 'Aggiungi alla Lista di Stampa',
    addedToCart: 'Collezione aggiunta alla lista di stampa',
    stats: 'Statistiche della Collezione',
    totalValue: 'Valore Totale',
    filteredValue: 'Valore Filtrato',
    cardCount: 'Conteggio Carte',
    totalCards: 'carte totali',
    uniqueCards: 'carte uniche',
    filteredCards: 'carte filtrate',
    rarityBreakdown: 'Distribuzione per Rarità',
    // Export feature
    export: 'Esporta Collezione',
    exporting: 'Esportazione in corso...',
    exportSuccess: 'Collezione esportata con successo',
    exportError: 'Impossibile esportare la collezione',
    noCardsToExport: 'Nessuna carta da esportare',
    exportCardName: 'Nome Carta',
    exportSet: 'Set',
    exportRarity: 'Rarità',
    exportQuantity: 'Quantità',
    exportPrice: 'Prezzo',
    exportTotalValue: 'Valore Totale',
    exportDateAdded: 'Data Aggiunta',
    // Quick add feature
    quickAdd: 'Aggiunta Rapida',
    searchCards: 'Cerca carte da aggiungere',
    typeToSearch: 'Digita almeno 3 caratteri per cercare',
    noResults: 'Nessun risultato trovato',
    noCardSelected: 'Nessuna carta selezionata',
    addCardToCollection: 'Aggiungi Carta alla Collezione',
    addCardDescription: 'Specifica la quantità da aggiungere alla tua collezione',
    quantity: 'Quantità',
    price: 'Prezzo',
    // Insights
    insights: 'Approfondimenti sulla Collezione',
    noInsightsAvailable: 'Nessun approfondimento disponibile per la tua collezione',
    insightsDescription: 'Statistiche dettagliate sulla tua collezione',
    rarityDistribution: 'Distribuzione per Rarità',
    topSets: 'Set Principali',
    priceDistribution: 'Distribuzione dei Prezzi',
    // Clear collection feature
    clearCollection: 'Cancella Collezione',
    clearCollectionConfirmTitle: "Cancellare l'Intera Collezione?",
    clearCollectionConfirmMessage: 'Questa azione non può essere annullata. Tutte le carte nella tua collezione saranno rimosse permanentemente.',
    // Edit card in collection
    editCardInCollection: 'Modifica Carta nella Collezione',
    editCardDescription: 'Aggiorna i dettagli di questa carta nella tua collezione.',
    viewCardDetails: 'Visualizza Dettagli Carta',
    condition: 'Condizione',
    selectCondition: 'Seleziona condizione',
    language: 'Lingua',
    selectLanguage: 'Seleziona lingua',
    finish: 'Finitura',
    selectFinish: 'Seleziona finitura',
    purchasePrice: 'Prezzo di Acquisto',
    isProxy: 'Questa è una proxy',
    saveChanges: 'Salva Modifiche',
    removeCard: 'Rimuovi Carta',
    cardRemoved: 'Carta rimossa dalla collezione',
    errorRemovingCard: 'Errore durante la rimozione della carta dalla collezione',
    errorSavingChanges: 'Errore durante il salvataggio delle modifiche alla carta',
    // Landing page
    landing: {
      title: 'Gestisci la Tua Collezione MTG',
      description: 'Tieni traccia di tutte le tue carte Magic: The Gathering in un unico posto con i nostri potenti strumenti di gestione della collezione.',
      intro: 'Il nostro sistema di gestione della collezione ti permette di tenere traccia, organizzare e valutare facilmente tutta la tua collezione di carte Magic: The Gathering. Crea un account oggi stesso per iniziare!',
      createAccount: 'Crea Account',
      getStarted: 'Inizia Ora',
      howItWorks: 'Come Funziona',
      step1: 'Crea un account gratuito per accedere alla tua collezione personale',
      step2: 'Aggiungi carte alla tua collezione manualmente o importale da un file CSV',
      step3: 'Organizza le tue carte per set, colore, rarità e altro',
      step4: 'Tieni traccia del valore della tua collezione nel tempo',
      step5: 'Esporta i dati della tua collezione quando ne hai bisogno',
    },
    features: {
      track: {
        title: 'Tieni Traccia delle Tue Carte',
        description: 'Mantieni un inventario dettagliato di tutte le tue carte Magic: The Gathering in un unico posto',
      },
      organize: {
        title: 'Organizza per Set',
        description: 'Ordina e filtra la tua collezione per set, rarità, colore e altro',
      },
      value: {
        title: 'Monitora il Valore',
        description: "Visualizza il valore di mercato attuale di tutta la tua collezione con un colpo d'occhio",
      },
      export: {
        title: 'Esporta Dati',
        description: 'Esporta i dati della tua collezione per utilizzarli in altre applicazioni',
      },
    },
  },
  pages: {
    search: {
      heading: 'Cerca',
    },
    sets: {
      heading: 'Set di Carte',
      latestSets: 'Ultimi Set',
      upcomingSets: 'Set in Arrivo',
      allSets: 'Tutti i Set',
      noResults: 'Nessun risultato trovato.',
    },
    set: {
      notFound: 'Set non trovato.',
      noCards: 'Nessuna carta trovata in questo set.',
      addAll: 'Aggiungi {{count}} Carte alla Lista di Stampa',
      addedToList: 'Aggiunte {{count}} carte alla Lista di Stampa',
    },
    tokens: {
      heading: 'Token',
    },
    emblems: {
      heading: 'Emblemi',
    },
    import: {
      heading: 'Importa carte nella Lista di Stampa',
      description: 'Inserisci i nomi di tutte le carte che vuoi aggiungere alla Lista di Stampa.',
    },
    topProxies: {
      heading: 'Proxy Popolari',
      description: 'Ecco le 50 carte proxy MTG più popolari su TCG Stacked.',
    },
  },
  hero: {
    game: {
      pokemon: {
        tab: 'Pokémon',
      },
      mtg: {
        tab: 'Magic: The Gathering',
      },
    },
    search: {
      cards: {
        placeholder: 'Cerca qualsiasi carta...',
      },
      sets: {
        placeholder: 'Cerca qualsiasi set di carte...',
      },
      button: 'Cerca',
      hint: {
        cards: 'Premi Invio o clicca Cerca per trovare le tue carte',
        sets: 'Premi Invio o clicca Cerca per trovare i tuoi set',
      },
      aria: {
        searchIcon: 'Icona di ricerca',
        searchInput: {
          cards: 'Cerca carte',
          sets: 'Cerca set',
        },
      },
    },
  },
  mtg: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['Carte', 'Terre', 'Creature', 'Artefatti', 'Planeswalker'],
      description: 'Cerca, sfoglia e crea proxy per le carte del Gioco di Carte Collezionabili Magic: The Gathering.',
      search: {
        cards: {
          tab: 'Carte',
          placeholder: 'Cerca qualsiasi carta MTG...',
          error: 'Impossibile recuperare carte MTG casuali',
        },
        sets: {
          tab: 'Set',
          placeholder: 'Cerca qualsiasi set di carte MTG...',
        },
        button: 'Cerca',
        hint: {
          cards: 'Premi Invio o clicca Cerca per trovare le tue carte',
          sets: 'Premi Invio o clicca Cerca per trovare i tuoi set',
        },
        aria: {
          searchIcon: 'Icona di ricerca',
          searchInput: {
            cards: 'Cerca carte Magic',
            sets: 'Cerca set Magic',
          },
        },
      },
      images: {
        cardAlt: 'Immagine carta Magic',
      },
      processedCount: 'Esplora oltre {{count}} carte Magic: The Gathering nel nostro database!',
    },
  },
  pokemon: {
    advancedFilters: {
      title: 'Filtri Avanzati',
      types: 'Tipi',
      rarities: 'Rarità',
      subtypes: 'Sottotipi',
      series: 'Serie',
      sets: 'Set',
      legalities: 'Legalità',
      hp: 'PS',
      hpRange: 'Intervallo PS',
      hpMin: 'PS Min',
      hpMax: 'PS Max',
      applyFilters: 'Applica Filtri',
      resetFilters: 'Reimposta',
      close: 'Chiudi',
    },
    search: {
      title: 'Ricerca Carte Pokémon',
      placeholder: 'Cerca carte Pokémon...',
      advancedFilters: 'Filtri Avanzati',
      noResults: 'Nessun risultato trovato. Prova a modificare i filtri.',
      error: 'Errore nella ricerca delle carte Pokémon',
    },
    hero: {
      title: 'Proxy',
      rotatingWords: ['Pokémon', 'Allenatori', 'Energie', 'Leggendari', 'Brillanti'],
      description: 'Cerca, sfoglia e crea proxy per le carte Pokémon.',
      search: {
        cards: {
          tab: 'Carte',
          placeholder: 'Cerca qualsiasi carta Pokémon...',
          error: 'Errore nel recupero delle carte Pokémon casuali',
        },
        sets: {
          tab: 'Set',
          placeholder: 'Cerca qualsiasi set di carte Pokémon...',
        },
        button: 'Cerca',
        hint: {
          cards: 'Premi Invio o clicca Cerca per trovare le tue carte',
          sets: 'Premi Invio o clicca Cerca per trovare i tuoi set',
        },
        aria: {
          searchIcon: 'Icona di ricerca',
          searchInput: {
            cards: 'Cerca carte Pokémon',
            sets: 'Cerca set Pokémon',
          },
        },
      },
      images: {
        cardAlt: 'Immagine carta Pokémon',
      },
      processedCount: 'Esplora oltre {{count}} carte Pokémon nel nostro database!',
    },
    sets: {
      heading: 'Set di Carte Pokémon',
      latestSets: 'Ultimi Set',
      upcomingSets: 'Set in Arrivo',
      allSets: 'Tutti i Set',
      noResults: 'Nessun risultato trovato.',
      sortBy: 'Ordina per',
      sort: {
        nameAsc: 'Nome (A-Z)',
        nameDesc: 'Nome (Z-A)',
        releaseDateDesc: 'Data di Uscita (Più Recente Prima)',
        releaseDateAsc: 'Data di Uscita (Più Vecchia Prima)',
      },
      filterBy: 'Filtra per serie',
      allSeries: 'Tutte le Serie',
    },
    set: {
      notFound: 'Set Pokémon non trovato.',
      backToSets: 'Torna ai Set',
      cards: 'carte',
      released: 'Pubblicato',
      noCards: 'Nessuna carta trovata in questo set.',
      tryAdjusting: 'Prova a modificare la tua ricerca per trovare ciò che stai cercando.',
      sortBy: 'Ordina per',
      filterBy: 'Filtra per',
      allTypes: 'Tutti i Tipi',
      allRarities: 'Tutte le Rarità',
      searchPlaceholder: 'Cerca carte in questo set...',
    },
    card: {
      notFound: 'Carta Pokémon non trovata.',
      backToSearch: 'Torna alla Ricerca',
      addToPrintList: 'Aggiungi alla Lista di Stampa',
      removeFromPrintList: 'Rimuovi dalla Lista di Stampa',
      inPrintList: 'Nella Lista di Stampa',
      buyOn: 'Acquista su TCGplayer',
      details: 'Dettagli',
      type: 'Tipo',
      rarity: 'Rarità',
      set: 'Set',
      artist: 'Artista',
      number: 'Numero Carta',
      flavorText: 'Testo di Ambientazione',
      attacks: 'Attacchi',
      abilities: 'Abilità',
      weakness: 'Debolezza',
      resistance: 'Resistenza',
      retreatCost: 'Costo di Ritirata',
      legality: 'Legalità',
      otherVersions: 'Altre Versioni',
      youMightAlsoLike: 'Potrebbe interessarti anche...',
    },
  },
  feedback: {
    buttonLabel: 'Feedback',
    title: 'Condividi il Tuo Feedback',
    description: 'Apprezziamo il tuo contributo per migliorare TCG Stacked. Condividi i tuoi pensieri con noi.',
    categoryLabel: 'Categoria',
    categories: {
      bug: 'Segnalazione Bug',
      feature: 'Richiesta Funzionalità',
      improvement: 'Suggerimento Miglioramento',
      general: 'Feedback Generale',
      other: 'Altro',
    },
    messageLabel: 'Il Tuo Feedback',
    messagePlaceholder: 'Condividi i tuoi pensieri, suggerimenti o segnala un problema...',
    ratingLabel: 'Valuta la Tua Esperienza (Opzionale)',
    emailLabel: 'Email (Opzionale)',
    emailPlaceholder: 'tua@email.com',
    emailHelp: 'Fornisci la tua email se desideri che ti contattiamo.',
    submitting: 'Invio in corso...',
    submitButton: 'Invia Feedback',
    successMessage: 'Grazie per il tuo feedback!',
    errorMessage: 'Impossibile inviare il feedback. Riprova.',
  },
  customizeCardModal: {
    title: 'Personalizza Carta con IA',
    description: "Descrivi come vuoi personalizzare questa carta. L'IA genererà una nuova versione mantenendo la cornice e la struttura della carta.",
    buttonText: 'Personalizza con IA',
    placeholder: 'Descrivi la tua variante personalizzata della carta...',
    generateButton: 'Genera Carta Personalizzata',
    generatingButton: 'Generazione in corso...',
    addToPrintListButton: 'Aggiungi alla Lista di Stampa',
    successMessage: 'Carta personalizzata aggiunta alla lista di stampa',
    cancelledGeneration: 'Generazione della carta annullata',
    remainingGenerationsOne: '{{count}} generazione rimanente questo mese',
    remainingGenerationsOther: '{{count}} generazioni rimanenti questo mese',
    error: {
      failed: 'Impossibile generare la carta personalizzata',
    },
  },
  creditPurchaseModal: {
    title: 'Acquista crediti di generazione IA',
    description: 'Acquista crediti di generazione IA aggiuntivi per personalizzare più carte.',
    buttonText: 'Acquista crediti',
    currentCredits: 'Crediti attuali',
    selectPackage: 'Seleziona pacchetto di crediti',
    purchase: 'Acquista ora',
    noCreditsWarning: 'Nessun credito disponibile',
    lowCreditsWarning: 'Pochi crediti rimanenti',
    buyCredits: 'Acquista crediti',
    remainingGenerationsOne: '{{count}} credito',
    remainingGenerationsOther: '{{count}} crediti',
    creditPackages: {
      small: 'Piccolo',
      medium: 'Medio',
      large: 'Grande',
    },
    loadingCredits: 'Caricamento informazioni crediti...',
    valuePerCredit: '${value}/credito',
    credits: 'Crediti',
    failedCheckout: 'Impossibile creare la sessione di pagamento',
  },
  ai: {
    pageTitle: "Personalizza le tue carte proxy con la magia dell'IA | TCG Stacked",
    pageDescription: "Trasforma le tue carte Magic: The Gathering con illustrazioni personalizzate generate dall'IA. Esclusivo per i membri Pro.",
    hero: {
      badge: 'Funzionalità Pro',
      title: "Personalizza le tue carte proxy con la magia dell'IA",
      subtitle: 'Crea illustrazioni personalizzate per i tuoi proxy Magic: The Gathering in pochi secondi',
      cta: "Prova l'abbonamento Pro gratuitamente",
    },
    features: {
      title: 'Potenti funzionalità IA a portata di mano',
      subtitle: 'La nostra personalizzazione IA ti offre un controllo creativo completo sulle tue carte proxy Magic: The Gathering',
      cardIntegrity: {
        title: "Preserva l'integrità della carta",
        description: "La nostra IA modifica solo l'illustrazione mantenendo perfettamente intatti il bordo della carta, il testo, i simboli di mana e il layout.",
      },
      creativity: {
        title: 'Creatività illimitata',
        description: "Trasforma le tue carte con qualsiasi tema o stile tu possa immaginare - dalla fantasia alla fantascienza, dal fotorealismo all'astratto.",
      },
      instantResults: {
        title: 'Risultati istantanei',
        description: 'Genera illustrazioni personalizzate in pochi secondi senza bisogno di competenze di design. Descrivi semplicemente ciò che vuoi vedere.',
      },
      saveCreations: {
        title: 'Salva le tue creazioni',
        description: "Tutte le tue carte generate dall'IA vengono salvate nel tuo account in modo da potervi accedere in qualsiasi momento dalla tua dashboard.",
      },
      printAnytime: {
        title: 'Stampa quando vuoi',
        description: 'Aggiungi le tue carte personalizzate alla tua lista proxy quando vuoi e stampale insieme al resto della tua collezione.',
      },
    },
    credits: {
      title: 'Crediti di generazione IA',
      subtitle: 'Personalizza e trasforma le tue carte proxy Magic: The Gathering con crediti di generazione IA potenti, convenienti e facili da usare.',
      howItWorks: 'Come funzionano i crediti',
      step1: {
        number: '1',
        title: 'Acquista crediti',
        description: 'in pacchetti che si adattano alle tue esigenze creative e al tuo budget',
      },
      step2: {
        number: '2',
        title: 'Genera illustrazioni personalizzate',
        description: 'per qualsiasi carta proxy Magic: The Gathering utilizzando 1 credito per generazione',
      },
      step3: {
        number: '3',
        title: 'Tieni traccia del tuo utilizzo',
        description: 'nella dashboard del tuo account e acquista altri crediti in qualsiasi momento',
      },
      proAdvantage: {
        title: 'Vantaggio per i membri Pro',
        description: 'I membri Pro ricevono 5 crediti mensili di generazione IA come parte del loro abbonamento. Unisciti a Pro per massimizzare il tuo potenziale creativo!',
      },
      purchaseButton: 'Acquista crediti ora',
      unlockProButton: 'Sblocca abbonamento Pro',
      packages: {
        title: 'Pacchetti di crediti',
        small: {
          name: 'Piccolo',
          credits: '5',
          price: '2.99',
          value: '$0.60/credito',
        },
        medium: {
          name: 'Medio',
          credits: '15',
          price: '7.99',
          value: '$0.53/credito',
          popular: 'Popolare',
        },
        large: {
          name: 'Grande',
          credits: '30',
          price: '13.99',
          value: '$0.47/credito',
        },
        createDesigns: 'Crea {{credits}} design di carte unici',
      },
    },
  },
};

export default translations;
